var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14.1558C28 21.8877 21.732 28.1558 14 28.1558C6.26801 28.1558 0 21.8877 0 14.1558C0 6.42377 6.26801 0.155762 14 0.155762C21.732 0.155762 28 6.42377 28 14.1558ZM6.0072 9.16099C5.83707 14.6774 8.67813 20.1351 15.0116 19.8085V16.0664C16.8416 16.1931 18.0762 17.3155 19.1917 19.8189H22C21.3414 17.4122 19.9925 15.6678 18.0483 14.5376C18.2524 14.3125 18.4604 14.0903 18.6686 13.8679C19.178 13.3237 19.6885 12.7785 20.1457 12.1858C20.8088 11.317 21.2367 10.2687 21.3827 9.15576H18.8394C18.1054 11.1287 17.1296 12.7933 14.969 13.3787V9.15968H12.3917V16.6308C9.30273 15.0707 8.88836 12.1662 8.65262 9.16099H6.0072Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.3326ee4e15ba62c9f5e3859183c134f1.svg";
export { ForwardRef as ReactComponent };